import { render, staticRenderFns } from "./internal-answers_others.vue?vue&type=template&id=673e8c4f"
import script from "./internal-answers_others.vue?vue&type=script&lang=js"
export * from "./internal-answers_others.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports